module.exports = __webpack_public_path__ + "static/media/finger.56949e8c.png";